(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('LenderContactSearch', LenderContactSearch);

    LenderContactSearch.$inject = ['$resource'];

    function LenderContactSearch($resource) {
        var resourceUrl =  'api/_search/lender-contacts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
